<template>
  <footer>
    <ul class="usb">
      <li v-for="usp in wizco.settings.content.usps" :key="usp._uid" v-editable="usp">
        <PflegeIcon :color="usp.color" name="checkmark-line" />
        <span>{{ usp.text }}</span>
      </li>
    </ul>
  </footer>
</template>

<script setup>
import { useWizcoStore } from '../../stores/wizco'
const wizco = useWizcoStore()
</script>

<style scoped>
.usb {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-content: space-between;
  align-items: flex-end;
  list-style: none;
  font-size: 14px;
  font-weight: 300;
  line-height: 1.14;
  background-color: var(--mint-light);
  box-shadow: 0 -2px 6px 0 rgba(164, 164, 164, 0.5);
  padding: 1rem 0.5rem;
  gap: 0.5rem;
  margin: 0;
  z-index: 8;
}

.usb:empty {
  background-color: transparent;
  opacity: 0;
}

.usb > li {
  display: grid;
  align-items: center;
  grid-template-columns: 1rem auto;
  gap: 0.5rem;
  justify-content: center;
  height: 100%;
}

@media (min-width: 576px) {
  .usb {
    display: flex;
    font-size: 18px;
    padding: 1rem;
    box-shadow: none;
    height: auto;
    margin-top: 1rem;
  }
}

@media (max-width: 576px) {
  .usb > li:nth-child(n + 4) {
    display: none;
  }
}
</style>
